import { Component, computed, input, output, signal, viewChild } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { RidAssessmentToast } from '../../components/rid-assessment-toast/rid-assessment-toast';
import { RidAudioButton } from '../../components/rid-audio-button/rid-audio-button';
import { RidBottomButton } from '../../components/rid-bottom-button/rid-bottom-button';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidSegmentedWordCard } from '../../components/rid-segmented-word-card/rid-segmented-word-card';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { WordToKlankConverter } from '../../utils/klank.utils';

@Component({
  selector: 'rid-dictation-physical',
  imports: [
    RidMechanicBackground,
    RidMechanicWrapper,
    RidTopBar,
    RidMechanicContent,
    RidMechanicTitle,
    RidAudioButton,
    RidBottomButton,
    RidAssessmentToast,
    RidSegmentedWordCard,
  ],
  templateUrl: './rid-dictation-physical.html',
  host: {
    class: 'block',
  },
})
export class RidDictationPhysical {
  words = input.required<{ word: string; audio: string }[]>();

  index = signal(0);
  audioButton = viewChild.required<RidAudioButton>('audioButton');
  segmentedWordCard = viewChild<RidSegmentedWordCard>('segmentedWordCard');
  word = computed(() => this.words()[this.index()]);
  state = signal<'AUDIO' | 'WRITING' | 'FEEDBACK'>('AUDIO');
  split = WordToKlankConverter.breakupWord.bind(WordToKlankConverter);

  finished = output<void>();

  async start() {
    await this.audioButton().play();

    this.state.set('WRITING');
  }

  next() {
    const isLastIndex = this.index() === this.words().length - 1;

    if (isLastIndex) {
      this.finished.emit();
    } else {
      this.index.set(this.index() + 1);
      this.state.set('AUDIO');
    }
  }

  async markCorrect() {
    this.next();
    await delay(500);
    this.start();
  }

  async markIncorrect() {
    this.next();
    await delay(500);
    this.start();
  }
}
